import { useRef } from 'react';
import { useMount, useUnmount } from 'react-use';

export function useTouchAndHold<T extends HTMLElement>(
  handler: () => void,
  delay: number
) {
  const ref = useRef<T>(null);
  const removeEventSignal = useRef(new AbortController());

  useMount(() => {
    // Вешаем обработчик на элемент
    ref.current?.addEventListener(
      'touchstart',
      (e) => {
        e.preventDefault();

        // Если пользователь не отпустил элемент в течении delay - выполняем действие
        const id = setTimeout(() => {
          handler();
        }, delay);

        // Отменяем таймер при отпускании
        ref.current?.addEventListener('touchend', () => {
          clearTimeout(id);
        });

        // Отменяем таймер при отмене сигнала (анамаунт хука)
        removeEventSignal.current.signal.addEventListener('abort', () => {
          clearTimeout(id);
        });
      },
      {
        signal: removeEventSignal.current.signal
      }
    );
  });

  useUnmount(() => {
    removeEventSignal.current.abort();
  });

  return ref;
}
